import { create } from 'zustand';

export type ToastTone = 'info' | 'success' | 'error' | 'people';
export interface Toast {
  id: number;
  title: string;
  body?: string;
  tone: ToastTone;
  duration: number;
}

interface ToastState {
  toasts: Toast[];
  push: (t: Omit<Toast, 'id' | 'duration' | 'tone'> & { tone?: ToastTone; duration?: number }) => number;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push: (t) => {
    const id = nextId++;
    const toast: Toast = { id, tone: t.tone ?? 'info', duration: t.duration ?? 4500, title: t.title, body: t.body };
    set((s) => ({ toasts: [...s.toasts.slice(-3), toast] }));
    return id;
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}));

export const toast = {
  info: (title: string, body?: string) => useToasts.getState().push({ title, body, tone: 'info' }),
  success: (title: string, body?: string) => useToasts.getState().push({ title, body, tone: 'success' }),
  error: (title: string, body?: string) => useToasts.getState().push({ title, body, tone: 'error', duration: 6000 }),
  people: (title: string, body?: string) => useToasts.getState().push({ title, body, tone: 'people' }),
};
